export default __webpack_public_path__ + "static/media/540.37a56ceb.jpg";